var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIntercominline = function SvgIntercominline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#intercom_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2m-3.867 2.934a.534.534 0 0 1 1.067 0v7.125a.534.534 0 0 1-1.067 0zm-2.666-.27a.534.534 0 0 1 1.067 0v7.733a.534.534 0 0 1-1.067 0zm-2.667.27a.534.534 0 0 1 1.066 0v7.125a.533.533 0 1 1-1.066 0zM2.134 4A.533.533 0 1 1 3.2 4v4.797a.534.534 0 0 1-1.066 0zm11.547 8.135c-.082.071-2.058 1.729-5.681 1.729-3.622 0-5.597-1.658-5.68-1.729a.533.533 0 0 1 .692-.81c.031.026 1.796 1.472 4.988 1.472 3.232 0 4.969-1.457 4.986-1.472a.533.533 0 1 1 .694.81m.186-3.338a.534.534 0 0 1-1.067 0V4a.533.533 0 1 1 1.066 0z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "intercom_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgIntercominline;